import { RefObject, useEffect } from 'react';

const isClickOutsideDropdown = (ref: RefObject<any>, event: MouseEvent) => {
  const portalClasses = ['ant-dropdown'];

  const isInDropdown = portalClasses.some((className) =>
    Array.from(document.querySelectorAll(`.${className}`)).some((popup) =>
      popup.contains(event.target as Node)
    )
  );

  return !(
    (ref.current instanceof HTMLElement && ref.current?.contains(event.target as Node)) ||
    isInDropdown
  );
};

export const useOutsideDropdownClick = (ref: RefObject<any>, onClickOutside: VoidFunction) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isClickOutsideDropdown(ref, event)) {
        onClickOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickOutside]);
};
